import { render } from "./BottomNavigation.vue?vue&type=template&id=2850ed77&scoped=true"
import script from "./BottomNavigation.vue?vue&type=script&lang=js"
export * from "./BottomNavigation.vue?vue&type=script&lang=js"

import "./BottomNavigation.vue?vue&type=style&index=0&id=2850ed77&lang=scss"
import "./BottomNavigation.vue?vue&type=style&index=1&id=2850ed77&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2850ed77"]])

export default __exports__